import type { Dayjs } from 'dayjs'

import { useDayjs } from '@shared/lib/format'

import { useProfileStore } from './store'

export const useAdminNow = (): Dayjs => useDayjs()().tz(useProfileStore().getTimezone)
